module.exports = __webpack_public_path__ + "static/media/55_000001.6e433ac5.jpg";